import React from 'react';

import DownloadIcon from 'assets/images/download-icon.svg';
import DocumentIcon from 'assets/images/document-icon.svg';
import Icon from 'shared/components/Icon';

import './styles.scss';

const SupportingDocuments = ({ copy, link, onClick = () => {} }) => {
  return (
    <div className="supporting-documents-container">
      <p className="title"> Supporting documents</p>
      <a className="download-box" href={link} onClick={onClick}>
        <Icon icon={DocumentIcon} />
        <span>{copy}</span>
        <Icon icon={DownloadIcon} />
      </a>
    </div>
  );
};

export default SupportingDocuments;
